import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import './Learn.css';

function BotGuideCard({ guide }) {
    return (
        <Link to={`/learn/${guide.id}`} className="learn-guide-card">
            <div className="learn-guide-card-top">
                <span className="learn-guide-card-icon" aria-hidden="true">
                    <Icon icon={guide.icon} />
                </span>
                <div className="learn-guide-card-meta">
                    <span className="learn-guide-badge">{guide.difficulty}</span>
                    <span className="learn-guide-time">{guide.timeEstimate}</span>
                </div>
            </div>
            <h2 className="learn-guide-card-title">{guide.title}</h2>
            <p className="learn-guide-card-text">{guide.description}</p>
            <span className="learn-guide-card-link">Read setup guide →</span>
        </Link>
    );
}

export default BotGuideCard;